export default "__VITE_ASSET__CkwkQgSG__"